import { useWishes } from '../../../../../redux/reducer/content';
import { useEffect, useState } from 'react';
import { eventSubscription } from '../../../../../utils/events/eventSubscription';

export default function useGetBackgroundId() {
  const { swiper, images, data, step } = useWishes();
  const [id, setId] = useState();

  useEffect(() => {
    if (step !== 0 || !swiper) return;
    return eventSubscription({
      target: swiper,
      callbacksBus: [
        {
          event: 'slideChange',
          callback: ({ realIndex }) => setId(images[realIndex]?.id),
        },
      ],
      actionAdd: 'on',
      actionRemove: 'off',
      postfix: '',
    });
  }, [images, swiper, step]);

  if (step === 1 || step === 2) return data?.image?.id;
  return id ?? images?.[0]?.id;
}
